var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#EEFFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28.5C16.4 28.5 15.51 29.4 15.51 30.5C15.51 31.6 16.4 32.5 17.5 32.5C18.6 32.5 19.5 31.6 19.5 30.5C19.5 29.4 18.6 28.5 17.5 28.5ZM27.5 28.5C26.4 28.5 25.51 29.4 25.51 30.5C25.51 31.6 26.4 32.5 27.5 32.5C28.6 32.5 29.5 31.6 29.5 30.5C29.5 29.4 28.6 28.5 27.5 28.5ZM26.05 23.5C26.8 23.5 27.46 23.09 27.8 22.47L31.38 15.98C31.4643 15.8284 31.5075 15.6575 31.5054 15.4841C31.5034 15.3106 31.456 15.1408 31.3681 14.9913C31.2803 14.8418 31.1548 14.7178 31.0043 14.6316C30.8538 14.5455 30.6834 14.5001 30.51 14.5H15.71L14.77 12.5H11.5V14.5H13.5L17.1 22.09L15.75 24.53C15.02 25.87 15.98 27.5 17.5 27.5H29.5V25.5H17.5L18.6 23.5H26.05ZM16.66 16.5H28.81L26.05 21.5H19.03L16.66 16.5Z",
    fill: "#0FAA8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreDetails);
export default __webpack_public_path__ + "static/media/store-details.42df06ebc1433abb5db0f61f39c46b05.svg";
export { ForwardRef as ReactComponent };